import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideRiskUi } from '@webapp/risk-core';

/** Slot names registered by the quoter side. */
export const QUOTER_RISK_SLOTS = { QUOTER_FORM: 'quoter-form', QUOTER_FLOW: 'quoter-flow' } as const;

const loadMotoQuadForm = () =>
	import('../risks/moto-quad/ui/components/moto-quad-quoter-form/moto-quad-quoter-form.component').then(
		(m) => m.MotoQuadQuoterFormComponent
	);

/**
 * Registers the quoter step-2 form slot of every migrated risk. Lives in the
 * quoter because the form components depend on quoter stores. The vehicle
 * family (MOTOR_BIKE, CLASSIC_CAR, QUAD), PERSONAL_ACCIDENTS and
 * TRANSPORTATION_GOODS.
 */
export function provideQuoterRiskUi(): EnvironmentProviders {
	return makeEnvironmentProviders([
		provideRiskUi('web', 'motor_bike', { [QUOTER_RISK_SLOTS.QUOTER_FORM]: { load: loadMotoQuadForm } }),
		provideRiskUi('web', 'quad', { [QUOTER_RISK_SLOTS.QUOTER_FORM]: { load: loadMotoQuadForm } }),
		provideRiskUi('web', 'personal_accidents', {
			[QUOTER_RISK_SLOTS.QUOTER_FORM]: {
				load: () =>
					import('../risks/personal-accidents/ui/components/personal-accidents-form/personal-accidents-form.component').then(
						(m) => m.PersonalAccidentsFormComponent
					),
			},
		}),
		provideRiskUi('web', 'transportation_goods', {
			[QUOTER_RISK_SLOTS.QUOTER_FORM]: {
				load: () =>
					import('../risks/transport/ui/components/transportation-goods-form/transportation-goods-form.component').then(
						(m) => m.TransportationGoodsFormComponent
					),
			},
		}),
		provideRiskUi('web', 'classic_car', {
			[QUOTER_RISK_SLOTS.QUOTER_FORM]: {
				load: () =>
					import('../risks/classic-car/ui/components/classic-car-form/classic-car-form.component').then(
						(m) => m.ClassicCarFormComponent
					),
			},
		}),
	]);
}

/**
 * Registers the mobile quoter flow of every migrated risk. The slot loads the
 * flow config (steps) and carries the route in `config`, so the mobile intro
 * can navigate without importing the config eagerly. MOTOR_BIKE, CLASSIC_CAR
 * and PERSONAL_ACCIDENTS: QUAD and TRANSPORTATION_GOODS have no mobile flow.
 */
export function provideQuoterMobileRiskUi(): EnvironmentProviders {
	return makeEnvironmentProviders([
		provideRiskUi('mobile', 'motor_bike', {
			[QUOTER_RISK_SLOTS.QUOTER_FLOW]: {
				load: () => import('../flows/moto-quoter-flow/moto-risk-config').then((m) => m.MOTO_RISK_CONFIG),
				config: { route: '/cotizar/moto' },
			},
		}),
		provideRiskUi('mobile', 'classic_car', {
			[QUOTER_RISK_SLOTS.QUOTER_FLOW]: {
				load: () =>
					import('../flows/classic-car-quoter-flow/classic-car-risk-config').then(
						(m) => m.CLASSIC_CAR_RISK_CONFIG
					),
				config: { route: '/cotizar/auto-clasico' },
			},
		}),
		provideRiskUi('mobile', 'personal_accidents', {
			[QUOTER_RISK_SLOTS.QUOTER_FLOW]: {
				load: () =>
					import('../flows/personal-accidents-quoter-flow/personal-accidents-risk-config').then(
						(m) => m.PERSONAL_ACCIDENTS_RISK_CONFIG
					),
				config: { route: '/cotizar/accidentes-personales' },
			},
		}),
	]);
}
